<template>
  <div>
    <div class="ui">
      {{ name }}
      <div class="viewController">
        <el-slider :max="scaleMax" @change="sendChangeScale" v-model="scaleSlider"/>
        <button @click="toggelGlobalVisible">Hide UI </button>
        <button @click="sendChangeScale(100)">x1</button>
        <button @click="sendChangeScale(50)">x0.5</button>
        <button @click="sendMovePosition({x: 0, y: 0})">move default</button>
      </div>
      <div class="ui-controller">
        <button @click="toggleVisible('canvas')">canvas</button>
        <button @click="toggleVisible('object')">object</button>
        <button @click="toggleVisible('image')">image</button>
        <button @click="toggleVisible('Video')">video</button>
      </div>
    </div>

    <canvas-controlPanel />
    <image-controlPanel />
    <object-controlPanel />
    <video-controlPanel />
    <popup-window />
  </div>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex'

import CanvasControlPanel from '@/components/canvas/controller'
import ImageControlPanel  from '@/components/image/controller'
import ObjectControlPanel from '@/components/object/controller'
import VideoControlPanel  from '@/components/video/controller'

import PopupWindow  from '@/components/popup-window'

export default {
  name: 'ToolBar',
  data () {
    return {}
  },
  props      : ['name'],
  components : {
    CanvasControlPanel,
    ImageControlPanel,
    ObjectControlPanel,
    VideoControlPanel,
    PopupWindow
  },
  computed: {
    ...mapGetters('room', [
      'scale',
      'scaleMax'
    ]),
    scaleSlider: {
      get () { return this.scale },
      set (value) { this.changeScale(value) }
    }
  },
  methods: {
    ...mapMutations('floatingWindow', [
      'toggleVisible',
      'toggelGlobalVisible'
    ]),
    ...mapActions('room', [
      'sendChangeScale',
      'sendMovePosition',
      'changeScale'
    ])
  }
}
</script>

<style scoped>
.ui {
  width    : 100vw;
  position : fixed;
  z-index  : 300;
  top      : 0;
  left     : 0;
  background-color : gray;
}
.viewController {
  display : inline-block;
  width   : 250px;
}
.ui-controller {
  display : inline-block;
  width   : 250px;

}
</style>



// WEBPACK FOOTER //
// src/components/room/controllers.vue